import * as actions from "../actions/support";

const supportInitialState = {
  activeTicket: null,
  supportHistory: null,
  zendeskTickets: null,
  filter: {
    subjectOrAddress: null,
    ticketStatus: null,
    ticketPriority: null,
  },
};

const supportReducer = (state = supportInitialState, action) => {
  switch (action.type) {
    case "RESET_STORE":
      return {
        ...supportInitialState,
      };
    case actions.UPDATE_ZENDESK_TICKETS:
      return {
        ...state,
        zendeskTickets: action.payload.zendeskTickets,
      };
    case actions.UPDATE_ACTIVE_ZENDESK_TICKET:
      return {
        ...state,
        activeTicket: action.payload.ticketContents,
        zendeskTickets: {
          ...state.zendeskTickets,
          [action.payload.ticketId]: action.payload.ticketContents,
        },
      };
    case actions.CLEAR_ACTIVE_ZENDESK_TICKET:
      return {
        ...state,
        activeTicket: null,
      };
    case actions.UPDATE_SUPPORT_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          [action.payload.filterKey]: action.payload.filterValue,
        },
      };
    case actions.CLEAR_SUPPORT_FILTER:
      return {
        ...state,
        filter: supportInitialState.filter,
      };

    default:
      return state;
  }
};

export default supportReducer;
